import React from 'react';
import { logEvent } from '@/etc/firebase';
import { useEffect, useState } from 'react';
import { Dialog, DialogTrigger, DialogContent } from '@/components/atoms/Dialog';
import { DISAPPOINTING_NEWS_OPTIONS } from '@/pages/NewsBriefing/_constants';
import { cn } from '@/utils/tailwind';
import { Check } from 'lucide-react';
import Button from '@/components/atoms/Button';
import FeedbackButton from '@/pages/NewsBriefing/_components/FeedbackButton';

interface DisappointingDialogProps {
  handleFeedback: (feedback: 'satisfying' | 'disappointing') => void;
}

export const DisappointingDialog: React.FC<DisappointingDialogProps> = ({ handleFeedback }) => {
  const [selected, setSelected] = useState<string>('');
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSubmit = () => {
    if (selected) {
      handleFeedback('disappointing');
      setDialogOpen(false);
      logEvent('submit_news_feedback', {
        feedback: 'disappointing',
        reason: selected,
        targetPage: 'pc_page',
      });
    }
  };

  useEffect(() => {
    setSelected('');
  }, [dialogOpen]);

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <FeedbackButton>😕 아쉬워요</FeedbackButton>
      </DialogTrigger>
      <DialogContent noCloseBtn className="w-fit gap-[20px] p-[30px]" noOverlay>
        <section className="flex flex-col gap-[4px]">
          <h2 className="text-gr-900 Title3S18">어떤 점이 아쉬웠나요?</h2>
          <h5 className="text-gr-700 Body5M14">
            보내주신 의견은 다음 뉴스에 반영할 수 있도록 노력할게요
          </h5>
        </section>
        <DisappointingReasonList selected={selected} onSelect={setSelected} />
        <Button
          onClick={handleSubmit}
          variant="point_default"
          className="h-[52px] rounded-[16px] Body1S16 disabled:bg-gr-200"
          disabled={!selected}
        >
          선택 완료
        </Button>
      </DialogContent>
    </Dialog>
  );
};

type Props = {
  selected: string;
  onSelect: (id: string) => void;
};

const DisappointingReasonList = ({ selected, onSelect }: Props) => {
  return (
    <div className="flex flex-col items-start gap-[12px]">
      {DISAPPOINTING_NEWS_OPTIONS.map(({ id, description }) => {
        const isSelected = selected === id;
        return (
          <button
            key={id}
            onClick={() => onSelect(isSelected ? '' : id)}
            className={cn(
              'flex h-[24px] w-full items-center justify-between text-[15px] font-medium leading-[22px] transition-colors duration-500',
              isSelected ? 'text-point-500' : 'text-gr-700',
            )}
          >
            <div>{description}</div>
            <Check
              className="h-[24px] w-[24px] text-point-500 transition-all duration-300"
              style={{ opacity: isSelected ? 1 : 0 }}
            />
          </button>
        );
      })}
    </div>
  );
};
